// import React from 'react'

// const Consulta = props => {
//     return <></>
// }

// export default Consulta

import React, { useState, useEffect, useRef } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-toastify/dist/ReactToastify.css';
import { Formik, Form, FieldArray } from "formik";
import Yup, { validaData, periodoData } from '../../../../util/Validacoes';
import { mostrarToast } from '../../../../components/Toasts'
import { useParams } from "react-router-dom";
import { ModalDuasOpcoes } from '../../../../components/Modais';
import { get, salvar, validar, consultar } from '../../../../util/AcessoApi'
import { HeaderCadastro } from '../../../../components/Headers'
import { Link } from 'react-router-dom'
import { InputPadrao, InputDatePicker, TextArea } from '../../../../components/Inputs'
import { InputUnidadeMedida, InputCor, InputSimNao, InputTipoProdutoBtn, InputCooperadoPfPj } from '../../../../components/InputsAutoComplete'
import { BotaoPadrao } from '../../../../components/Botoes'
import { mensagens, useInterval } from '../../../../util/Utilitarios'
import '../../../../assets/css/icones/iconsmind/style.css'
import Atalho from '../../../../util/Atalho'
import { BtnAcao } from '../../../../components/Acoes';
import { DetalhesComprovante } from './Visualizacao';

const CadastroLoteDevolucao = (props) => {
    let { id } = useParams()

    const [salvarENovo, setSalvarENovo] = useState(false)
    const [salvando, setSalvando] = useState(false)
    const [valoresIniciais, setValoresIniciais] = useState({})
    const [showModalValidacao, setShowModalValidacao] = useState(false)
    const [mensagemModal, setMensagemModal] = useState('')
    const [showValidacao, setShowValidacao] = useState(false)
    const [msgValidacao, setMsgValidacao] = useState('')
    const refTipoProduto = useRef();

    const [validacao] = useState(Yup.object({
        cooperado: Yup.string().nullable().required(),
    }).shape({
        comprovantes: Yup.array()
            .of(
                Yup.object().shape({
                    codigo_barras: Yup.string().test('Código Barras', 'Campo obrigatório!', function (value, context) { return this.parent.hospital && !this.parent.codigo_comprovante && !value ? false : true }).nullable(),
                    codigo_comprovante: Yup.string().test('Código Barras', 'Campo obrigatório!', function (value) { return this.parent.hospital && !value ? false : true }).nullable()
                }))
    }))

    const funcaoAposSim = (formik) => {
        Submit(formik.values, formik.resetForm)
    }

    const manter = ['produto_tipo']

    const validar = (values, propsFormik) => {
        setSalvando(true)
        Promise.resolve(get(`/devolucao/validardevolucao`, values, true)).then(val => {
            console.log('val: ', val);
            if (val && val.length) {
                var messageVal = val.map(x => `${x}<br /><br />`);
                setMsgValidacao(`${messageVal}<b>Deseja Continuar?</b>`)
                setShowValidacao(true)
            }
            else {
                const newFormik = { ...propsFormik }
                newFormik.values = { ...values }
                Submit(values, newFormik)
            }
        })
    }

    const Submit = (values, propsFormik) => {
        setSalvando(true)

        salvar(
            values,
            '/devolucao/lote',
            () => {
                mostrarToast('sucesso', mensagens.sucesso)

                if (salvarENovo) {
                    propsFormik.resetForm({})
                    manter.forEach(x => propsFormik.setFieldValue(x, values[x]))
                    setSalvando(false)
                    setSalvarENovo(false)
                    document.getElementById("cooperado").focus();
                }
                else
                    props.history.push('/devolucao/lote/consulta')
            },
            () => {
                setSalvando(false)
            })
    }

    useEffect(() => {
        if (id) {
            Promise.resolve(get(`/devolucao/lote/${id}`)).then(val => {
                if (!val.id)
                    props.history.push('/devolucao/lote/consulta')

                val.comprovantes = [...val.comprovantes, { codigo_barras: null, codigo_comprovante: null }]

                setValoresIniciais(val)
            })
        } else {
            setValoresIniciais({
                cooperado: null,
                comprovantes: [{ codigo_barras: null, codigo_comprovante: null }]
            })
        }

    }, [id])

    return (<Formik
        initialValues={valoresIniciais}
        validationSchema={validacao}
        enableReinitialize={true}
        onSubmit={validar}>
        {propsFormik => (<Form>
            <div className={props.modal ? '' : 'card mb-20'}>
                <div className={props.modal ? '' : 'card-body'}>
                    <div className='row'>
                        <InputPadrao label="Id" name="id" type="hidden" placeholder="Id" obrigatorio={true} />

                        <InputCooperadoPfPj label="Cooperado" name="cooperado" placeholder="Cooperado" propsFormik={propsFormik} obrigatorio={true} tamanho='col-xl-4 col-lg-5 col-md-6'
                            salvarENovo={salvarENovo} />

                        <CadastroComprovante alteracao={!!props.id} formikCadastro={propsFormik}
                            // setPermitidoSalvar={setPermitidoSalvar}
                            //     abrirModal={modalProcedimentos} 
                            //     setAbrirModal={setModalProcedimentos} 
                            //     formikProcedimentos={(formik) => setFormikProcedimentos(formik)}
                            dataPlantao={propsFormik.values.data_inicial} />

                        <Atalho formik={propsFormik} salvando={salvando} setSalvareNovo={setSalvarENovo} salvarENovo={true} />
                    </div>
                </div>
            </div>
            <div className='separator mt-40 mb-5'></div>
            <div className='direita container-botoes mb-3 group-salvar-novo'>
                <BotaoPadrao texto='Salvar' disabled={salvando} click={_ => setSalvarENovo(false)} idTooltip={'salvar'} />
                {!id && <BotaoPadrao texto='Salvar e Novo' disabled={salvando} click={_ => setSalvarENovo(true)} idTooltip={'salvarENovo'} />}
            </div>
            <ModalDuasOpcoes showModal={showValidacao} setShowModal={setShowValidacao} funcaoOpcao2={_ => { Submit(propsFormik.values, propsFormik); setShowValidacao(false) }} funcaoOpcao1={_ => { setSalvando(false); setShowValidacao(false) }}
                esconderFechar mensagem={msgValidacao}
                textoOpcao1={'Cancelar'}
                classeOpcao1={'btn-sm btn-primary-modal simples'}
                textoOpcao2={'Continuar'} />
        </Form>)}
    </Formik>);
}

const CadastroComprovante = (props) => {
    const [itemDetalhes, setItemDetalhes] = useState();
    const [showModal, setShowModal] = useState(false);
    const onChangeCodigos = (propsFormik, arrayHelpers, index, campo) => {
        let item = null
        const arrayComprovantes = [...propsFormik.values.comprovantes]
        const obj = arrayComprovantes[index]

        if (!propsFormik.values.cooperado || !propsFormik.values.cooperado.value) {
            mostrarToast('erro', `Escolha um cooperado.`)
            return;
        }

        if (obj.codigo_barras || obj.codigo_comprovante) {
            Promise.resolve(get(`/devolucao/obterComprovante`, { codigo_barras: obj.codigo_barras, codigo_comprovante: obj.codigo_comprovante, campo: campo })).then(val => {
                if (val && val.length > 0) {
                    item = val[0]

                    const codigoBarrasAtual = obj.codigo_barras || item.codigo_barras
                    const codigoComprovanteAtual = obj.codigo_comprovante || item.codigo_comprovante

                    if (arrayComprovantes.filter((x, idx) => (((codigoBarrasAtual && x.codigo_barras === codigoBarrasAtual) || (codigoComprovanteAtual && x.codigo_comprovante === codigoComprovanteAtual)) && idx !== index)).length > 0) {
                        mostrarToast('erro', `Comprovante ${obj.codigo_barras || obj.codigo_comprovante} já adicionado!`)
                        return;
                    }

                    if (propsFormik.values.cooperado.tipo_pessoa === 1 && propsFormik.values.cooperado.value !== item.copf_id) {
                        mostrarToast('erro', `O Comprovante de Anestesia não pertece ao Cooperado selecionado.`)
                        return;
                    }

                    if (propsFormik.values.cooperado.tipo_pessoa === 2 && propsFormik.values.cooperado.value !== item.copj_id) {
                        mostrarToast('erro', `O Comprovante de Anestesia não pertece ao Cooperado selecionado.`)
                        return;
                    }

                    if (item) {
                        arrayComprovantes[index] = item

                        propsFormik.setFieldValue('comprovantes', arrayComprovantes);

                        adicionarLinha(arrayHelpers, propsFormik)
                    } else {
                        propsFormik.setFieldValue('comprovantes', arrayComprovantes);
                    }

                } else {
                    // document.getElementsByName(obj.codigo_barras ? `comprovantes[${index}].codigo_barras` : `comprovantes[${index}].codigo_comprovante`)[0].focus()
                    if (!obj.hospital)
                        mostrarToast('erro', `Comprovante ${obj.codigo_barras || obj.codigo_comprovante} não encontrado!`)
                }
            })
        }
    }

    const adicionarLinha = (arrayHelpers, propsFormik) => {
        const arrayProced = propsFormik.values.comprovantes;
        if (podeAdicionar(arrayProced)) {
            arrayHelpers.insert(propsFormik.values.comprovantes.length, { codigo_barras: '', codigo_comprovante: '' })

            let arrayLinhas = document.getElementsByClassName(`to-focus`)
            if (arrayLinhas)
                arrayLinhas[arrayLinhas.length - 1].focus()
        }
    }

    const podeAdicionar = (arrayProced) => {
        if (!arrayProced) return false;
        const ultimoObj = arrayProced[arrayProced.length - 1]
        if (ultimoObj.codigo_barras || ultimoObj.codigo_comprovante) return true;
    }

    const removerLinha = (arrayHelpers, propsFormik, index) => {
        const arrayProced = propsFormik.values.comprovantes;
        if (arrayProced.length === 1) {
            propsFormik.setFieldValue('comprovantes', [{ codigo_barras: '', codigo_comprovante: '' }])
        } else {
            if (index === arrayProced.length - 1)
                arrayHelpers.insert(propsFormik.values.comprovantes.length, { codigo_barras: '', codigo_comprovante: '' })
            arrayHelpers.remove(index)
        }
    }

    const visualizar = (item) => {
        setItemDetalhes(item)
        setShowModal(true)
    }

    return (
        <>
            <div className='col-12 bt-cinza'>
                <h3 className='mt-20 mb-20'><span>{'Comprovantes'}</span></h3>
                <div className="mt-2">
                    <div className="custom-scrollbar">
                        <FieldArray name="comprovantes">
                            {(arrayHelpers => (
                                <>
                                    {props.formikCadastro.values.comprovantes ?
                                        props.formikCadastro.values.comprovantes.map((item, index) => <div className='modal-body-cadastro row mr-0 ml-0'>

                                            {/* <div class="col-xl-2 col-lg-3 col-md-4">{index === 0 ? <label>Código de barras</label> : <></>}
                                                <div>
                                                    <span>{props.formikCadastro.values.comprovantes[index].codigo_barras}</span>
                                                </div>
                                            </div>

                                            <div class="col-xl-2 col-lg-3 col-md-4">{index === 0 ? <label>Código Comprovante</label> : <></>}
                                                <div>
                                                    <span>{props.formikCadastro.values.comprovantes[index].codigo_comprovante}</span>
                                                </div>
                                            </div> */}

                                            <div class="col-xl-2 col-lg-3 col-md-4">
                                                <div className='row'>
                                                    <div className='col-1 pr-0 pl-0'>
                                                        {index === 0 ? <label class='font-weight-bold'>#</label> : <></>}
                                                        <div className='pt-1'>
                                                            <span>{index + 1}</span>
                                                        </div>
                                                    </div>
                                                    <div className='col-11 pr-0 pl-0'>
                                                        <InputPadrao label={index === 0 ? 'Cód. de barras' : undefined} mascara="111.111.111-11"
                                                            onBlur={() => { onChangeCodigos(props.formikCadastro, arrayHelpers, index, 1) }} className='to-focus'
                                                            name={`comprovantes[${index}].codigo_barras`} placeholder="Código de barras" tamanho="pr-0 pl-0" classLabel='font-weight-bold' />
                                                    </div>
                                                </div>
                                            </div>

                                            <InputPadrao label={index === 0 ? 'Cód. Comprovante' : undefined}
                                                onBlur={() => { onChangeCodigos(props.formikCadastro, arrayHelpers, index, 2) }}
                                                name={`comprovantes[${index}].codigo_comprovante`} placeholder="Código Comprovante" tamanho="col-xl-2 col-lg-3 col-md-4" classLabel='font-weight-bold' />

                                            <div class="col-xl-2 col-lg-3 col-md-4">{index === 0 ? <label class='font-weight-bold'>Nome</label> : <></>}
                                                <div className='pt-1'>
                                                    <span>{props.formikCadastro.values.comprovantes[index].nome}</span>
                                                </div>
                                            </div>

                                            <div class="col-xl-1 col-lg-3 col-md-4">{index === 0 ? <label class='font-weight-bold'>Convênio</label> : <></>}
                                                <div className='pt-1'>
                                                    <span>{props.formikCadastro.values.comprovantes[index].convenio}</span>
                                                </div></div>

                                            <div class="col-xl-1 col-lg-3 col-md-4">{index === 0 ? <label class='font-weight-bold'>Hospital</label> : <></>}
                                                <div className='pt-1'>
                                                    <span>{props.formikCadastro.values.comprovantes[index].hospital}</span>
                                                </div></div>

                                            <div class="col-xl-1 col-lg-3 col-md-4">{index === 0 ? <label class='font-weight-bold'>Tipo Pessoa</label> : <></>}
                                                <div className='pt-1'>
                                                    <span>{props.formikCadastro.values.comprovantes[index].tipo_pessoa}</span>
                                                </div></div>

                                            <div class="col-xl-2 col-lg-3 col-md-4">{index === 0 ? <label class='font-weight-bold'>Status</label> : <></>}
                                                <div className='pt-1'>
                                                    <span>{props.formikCadastro.values.comprovantes[index].status}</span>
                                                </div></div>

                                            <div class="col-4 col-xl-1 col-lg-2 col-md-2">{index === 0 ? <label class='font-weight-bold'>Ações</label> : <></>}
                                                <div className=' mb-0 pr-0 pl-1 pb-3 row-start'>
                                                    <BtnAcao type={'button'} icone="icon-File-Search" texto="Visualizar" action={() => props.formikCadastro.values.comprovantes[index].hospital ? visualizar(props.formikCadastro.values.comprovantes[index]) : () => { }} />
                                                    <BtnAcao type={'button'} icone="icon-New-Trash" texto="Remover" action={() => removerLinha(arrayHelpers, props.formikCadastro, index)} />
                                                </div>
                                            </div>
                                        </div>)
                                        :
                                        <></>}
                                </>
                            ))}
                        </FieldArray>
                    </div>
                </div>
                <DetalhesComprovante itemDetalhes={itemDetalhes} showModal={showModal} setShowModal={setShowModal} />
            </div>
        </>)
}

const Cadastro = (props) => {
    const links = [
        () => <Link to={'/dashboard'}>Dashboard</Link>,
        () => <Link to={'#'}>Devolução</Link>,
        () => <Link className="link-active" to={'/devolucao/lote/consulta'}>Lote</Link>,
    ]
    return (<>
        <HeaderCadastro titulo={"Cadastro de Lote de Devolução"} link={links} />
        <CadastroLoteDevolucao {...props} />
    </>
    )
}
export { CadastroLoteDevolucao, CadastroComprovante }
export default Cadastro
